<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">
                    <!-- <b-card-header class="py-1 mb-2">
          <i :class="options.icon" class="text-primary mr-1"></i>
          {{ item.name }}
          <span class="text-warning"
            >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
          >
        </b-card-header> -->
                    <b-card-body class="py-0 px-0">
                        <b-tabs class="gridtabs">
                            <b-tab active>
                                <template #title>
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    {{ item.name }}
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Name" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.name" :debounce="options.debounce"
                                                        :disabled="readonly" placeholder="Enter Name"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.name = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="item.eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..."
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Value" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.value" :debounce="options.debounce"
                                                        :disabled="readonly" placeholder="Enter Value"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.value = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="InvoiceNo" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.invoiceno" :debounce="options.debounce"
                                                        :disabled="readonly" placeholder="Enter invoiceno"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.invoiceno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Agent" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input :disabled="readonly" v-model="item.agent"
                                                        :debounce="options.debounce"
                                                        placeholder="Enter Agent"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.agent = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Status" label-for="status" label-cols="12" size="sm">
                                                <treeselect instanceId="status" type="number" v-model="item.status"
                                                    :clearable="false" :options="status_options" :disabled="readonly">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Source Type" label-for="type" label-cols="12" size="sm">
                                                <treeselect instanceId="type" type="number" v-model="item.type"
                                                    :clearable="false" :options="type_options" :disabled="true">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>


                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Last Message" label-for="message" label-cols="12">
                                                <b-form-textarea id="message" v-model="item.message"
                                                    placeholder="Last Message" rows="3"
                                                    class="smalltextarea"></b-form-textarea> </b-form-group></b-col></b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Queued At" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.queued_at" :debounce="options.debounce"
                                                        :disabled="readonly" placeholder="Enter queued at"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.queued_at = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Queued but already allocated?"
                                                label-size="sm">
                                                <b-button squared size="sm" variant="info" @click="allocateit()"
                                                    v-if="!readonly">
                                                    <i class="fa fa-paper-plane"></i>
                                                    Allocated?
                                                </b-button>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-file-code-o text-primary mr-1"></i>
                                    Data</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Data" label-for="data" label-cols="12">
                                                <b-form-textarea id="data" v-model="xml" placeholder="Enter data" rows="12"
                                                    class="smalltextarea courier" :disabled="readonly"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                </p>
                            </b-tab>
                            <b-tab v-if="item.id">
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i>Audit
                                </template>
                                <p class="py-3 px-0">

                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                </p>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>
                    <b-card-footer class="mt-2 px-0">
                        <b-row>
                            <b-col class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()" v-if="!readonly">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>

                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col cols="8" class="text-right">
                                <b-button squared size="sm" variant="secondary" class="mr-1" @click="$emit('discard')">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>

                            </b-col>
                        </b-row>
                    </b-card-footer></b-card>
            </div>
        </b-card>
    </b-overlay>
</template>
  
<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
    name: "QueueEdit",
    data() {
        return {
            busy: false,
            options: {
                title: "Queue",
                icon: "fa fa-stack-overflow",
            },
            xml: null,
            type_options: [
                { id: "0", label: "BulkticketV" },
                { id: "1", label: "BulkticketB" },
                { id: "2", label: "BarclayCard" },
                { id: "3", label: "ConfermaPay" },
            ],
            status_options: [
                { id: 0, label: "Posted" },
                { id: 1, label: "Pending" },
                { id: 2, label: "Error" },
            ],
            item: {
                created_at: this.$moment().format("YYYY-MM-DD"),
                queued_at: null,
                type: null,
                eventcode: null,
                slac: null,
                name: null,
                agent: null,
                ticketno: null,
                passenger: null,
                isinvoiced: null,
                yourref: null,
                value: null,
                status: null,
                message: null,
                invoiceno: null,
                data: null
            },
        };
    },
    computed: {
        readonly() {
            if (this.user.permissions.includes('queue.save')) {
                return false
            }
            return true;
        },
    },
    methods: {
        async load() {
            if (!this.idselected) {
                return;
            }
            this.busy = true;
            let variables = {
                id: this.selection[0].id,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
            query queue(
                $id: String
            ) {
              queue(
                id: $id
              ) {
                id
                name
                eventcode
                slac
                agent
                value
                invoiceno
                status
                type
                message
                data
                queued_at
                created_at
                created_by
                updated_by
                updated_at  
              }
            }
          `,
                    variables,
                });
                console.log("load", response);

                this.item = response.data.queue[0];
                this.item.queued_at = this.$moment.unix(this.item.queued_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm:ss");
                this.xml = null
                if (this.item) {
                    this.xml = Buffer.from(this.item.data, "base64").toString("ascii");
                }

            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {
            this.busy = true;

            let row = this.cleanit(this.item)

            // row.ticketno = row.ticketno.join(",")

            let variables = {
                rows: [this.cleanit(row)],
            };
            variables.rows[0].data = Buffer.from(this.xml, "ascii").toString("base64");

            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation queue_save($rows: [Queue_input]) {
                queue_save(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });

                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async allocateit() {
            this.busy = true;

            let variables = {
                queued: [this.cleanit(this.item)]
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query tickets_draftinvoice(
                        $queued: [Queue_input]
                        ) {
                        tickets_draftinvoice(
                            queued: $queued
                        ) {
                            ref
                            to
                            address
                            dateref
                            slac
                            agent
                            yourref
                            eventname
                            vatregion
                            saletotal
                            terms
                            credit
                            id
                            data
                            document {
                            fields {
                                key
                                label
                                class
                            }
                            items
                            }
                            message
                            level
                        }
                        }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });
                if (response.data.tickets_draftinvoice.length > 0) {
                    this.item.message = response.data.tickets_draftinvoice[0].message

                    let values = this.item.message.split('\n')
                    if (values.length > 0) {
                        if (values[0].includes('already invoiced ticket')) {
                            console.log(values)
                            let parts = values[0].split(' on ')
                            this.item.invoiceno = parts[1]
                            this.item.status = 0
                        }
                    }
                }

            } catch (error) {
                console.log(error);
            }

            this.busy = false;
        }
    },
};
</script>
  
<style></style>